module.exports = __webpack_public_path__ + "img/mei-stressed.png";